import { createSlice } from '@reduxjs/toolkit';

interface DataState {
    profile: boolean,
    link: any,
    webOpen: boolean
    langOpen: boolean,
    selectLang: any,
    searchOpen: boolean,
    headerMenuData: any,
    subMegaMenuOpen: boolean,
    selectMenuIndex: any
}

const initialState: DataState = {
    profile: false,
    link: null,
    webOpen: false,
    langOpen: false,
    selectLang: null,
    searchOpen: false,
    headerMenuData: null,
    subMegaMenuOpen: false,
    selectMenuIndex: null
}

const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setProfile: (state, action) => {
            state.profile = action.payload;
        },
        setLink: (state, action) => {
            state.link = action.payload;
        },
        setWebOpen: (state, action) => {
            state.webOpen = action.payload;
        },
        setLangOpen: (state, action) => {
            state.langOpen = action.payload;
        },
        setSelectLang: (state, action) => {
            state.selectLang = action.payload;
        },
        setSearchOpen: (state, action) => {
            state.searchOpen = action.payload;
        },
        setHeaderMenuData: (state, action) => {
            state.headerMenuData = action.payload;
        },
        setSubMegaMenuData: (state, action) => {
            state.subMegaMenuOpen = action.payload;
        },
        setSelectMenuIndex: (state, action) => {
            state.selectMenuIndex = action.payload;
        },
    }
});

export default dataSlice;
export const dataActions = dataSlice.actions;